import styled from 'styled-components';
import {
  Text,
  Icon,
  UNIVERSAL_SEARCH_ANSWERING_DROPDOWN_WIDTH,
} from 'components';
import { BB_ASSUME_INPUT_CLASS } from './BBAssumeNavbar';

export const StyledContent = styled.div<{
  $md: boolean;
  $height: number;
  $transition: number;
  $color: string;
}>`
  background-color: ${({ $color }) => $color};
  height: ${({ $height }) => $height}px;
  display: flex;
  flex-wrap: wrap;
  overflow: hidden;
  padding: 0 15px;
  width: 100vw;
  transition: ${({ $transition }) => `height ${$transition}s`};

  ${Text} {
    color: inherit;
  }

  .assume-row {
    width: 100%;
    > * {
      margin: 0 5px;
      display: flex;
    }
  }
  .dropdown-column {
    min-width: 135px;
    font-size: 11px;
    line-height: 14px;
    color: white;
  }
  .${BB_ASSUME_INPUT_CLASS} {
    padding: 1px 5px;
    border-radius: 10px;
    font-size: 11px;
    line-height: 0;
    outline: none;
    border: none;
    width: ${({ $md }) => (!$md ? '100%' : '230px')};
  }
  .assume-button,
  .unassume-button,
  .exit-button,
  .change-button {
    padding: 0 5px;
    height: 100%;
    width: 100%;
    display: flex;
    font-size: 11px;
    line-height: 14px;
    color: white;
  }
  .search-icon {
    margin-right: 5px;
  }
  .close-column {
    display: flex;
    justify-content: flex-end;
    button {
      height: 100%;
      display: flex;
      background-color: white;
      border-radius: 50%;
      min-width: auto;
      width: auto;
      padding: 0;
    }
    ${Icon} {
      color: ${({ $color }) => $color};
    }
  }
`;

export const StyledSearchWrapper = styled.div`
  position: fixed;
  background-color: white;
  width: ${UNIVERSAL_SEARCH_ANSWERING_DROPDOWN_WIDTH}px;
  max-width: 100vw;
  box-shadow: 0px 3px 14px 0px rgba(0, 0, 0, 0.75);
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  > button {
    line-height: 0;
  }
`;
